module.exports = __webpack_public_path__ + "img/announce-1.1208a79b.png";